import api from '../client';

export const ExchangeService = {
  getCredentials: () => api.get('/exchange/credentials'),
  setCredentials: (ncUsername, ncPassword) => {
    const formData = new FormData();
    formData.append('nc_username', ncUsername);
    formData.append('nc_password', ncPassword);
    return api.post('/exchange/credentials', formData);
  },
  
  getAdminCredentials: (userId) => api.get(`/exchange/admin/credentials/${userId}`),
  setAdminCredentials: (userId, ncUsername, ncPassword) => {
    const formData = new FormData();
    formData.append('nc_username', ncUsername);
    formData.append('nc_password', ncPassword);
    return api.post(`/exchange/admin/credentials/${userId}`, formData);
  },
  
  listFiles: (path = '/') => api.get(`/exchange/files?path=${encodeURIComponent(path)}`),
  
  uploadFile: (path, file) => {
    const formData = new FormData();
    formData.append('path', path);
    formData.append('file', file);
    return api.post('/exchange/upload', formData);
  },
  
  downloadFile: (path) => api.get(`/exchange/download?path=${encodeURIComponent(path)}`, { responseType: 'blob' }),
  
  deleteItem: (path) => api.delete(`/exchange/delete?path=${encodeURIComponent(path)}`),
  
  createFolder: (path) => {
    const formData = new FormData();
    formData.append('path', path);
    return api.post('/exchange/mkdir', formData);
  },
  
  moveItem: (srcPath, dstPath) => {
    const formData = new FormData();
    formData.append('src_path', srcPath);
    formData.append('dst_path', dstPath);
    return api.post('/exchange/move', formData);
  },
  
  createShare: (path, shareType = 3, permissions = 1, expireDate = null) => {
    return api.post('/exchange/share', { path, share_type: shareType, permissions, expire_date: expireDate });
  },
  
  getShares: (path = null) => api.get(`/exchange/shares${path ? `?path=${encodeURIComponent(path)}` : ''}`),
  
  deleteShare: (shareId) => api.delete(`/exchange/share/${shareId}`),
  
  shareToChat: (path, roomId) => {
    const formData = new FormData();
    formData.append('path', path);
    formData.append('room_id', roomId);
    return api.post('/exchange/share-to-chat', formData);
  },
  
  openInNc: (path) => api.get(`/exchange/open-in-nc?path=${encodeURIComponent(path)}`),
  
  testConnection: () => api.get('/exchange/test-connection'),
};
